<template>
  <el-row class="main-bottom">
    <div class="main-bottom-conts">

      <el-col
        
       style="float: left;
    width: 400px;
    margin-left: 150px;
    margin-top: 25px;"
        
      >
        <div style="font-size: 25px" class="title">株洲市芦淞区中医骨伤专科医院</div>
        <li>
         <a href="#">Lusong District Traditional Chinese Medicine Orthopedic Specialty Hospital Co. Ltd</a>
        </li>
       
      </el-col>

      <!-- <el-col class="item-box" :xs="{span:12}" :sm="{span:6}" :md="{span:5}" :lg="{span:2}">
        <div class="title">联系方式</div>
        
       <li>
          <router-link to="/main/aboutUS"><a href="27481120">电话</a></router-link>
        </li>
        <li>
          <router-link to="/main/aboutUS"><a href="#">电子邮箱</a></router-link>
        </li>
        <li>
          <router-link to="/main/aboutUS"><a href="#">信息平台</a></router-link>
        </li>
                <li>
          <router-link to="/main/aboutUS"><a href="#">邮寄地址</a></router-link>
        </li>

      </el-col> -->
            <el-col class="item-box" :xs="{span:12}" :sm="{span:6}" :md="{span:5}" :lg="{span:2}">
        <div class="title">联系方式</div>
        
       <li>
          <router-link to=""><a href="#">电话 27481120</a></router-link>
        </li>
        <li>
          <router-link to=""><a href="#">邮箱 1141467187@qq.com</a></router-link>
        </li>
        <li>
          <router-link to=""><a href="#">公众号 “株洲市芦淞区中医骨伤专科医院”</a></router-link>
        </li>
            <li>
          <router-link to=""><a href="#">地址 株洲市芦淞区白关镇姚家坝村新街</a></router-link>
        </li>
            <li>
          <router-link to=""><a href="#">24小时值班制</a></router-link>
        </li>
      </el-col>


      <el-col
        class="item-box"
        :xs="{span:24}"
        :sm="{span:15}"
        :md="{span:10,offset:2}"
        :lg="{span:5,offset:0}"
      >
        <!-- <div style="color: white;font-size: 30px">27481120</div>
       
        <li>地址：株洲市芦淞区白关镇姚家坝村新街 </li>
        <li>24小时值班制</li> -->
      </el-col>
      <el-col class="item-box code" :xs="{span:24}" :sm="{span:6}" :md="{span:6}" :lg="{span:3}">
        <img :src="require('@/assets/yyimages/wx-1.png')" />
        <p class="codetext">扫一扫，关注我们</p>
      </el-col>
    </div>
    <div class="main-bottom-copyright">
      <p>Copyright&copy;2025 hunan. All Rights Reserved.</p>
      <p>芦淞区中医骨伤专科医院版权所有</p>
      <p>
        <a target="_blank" href="http://beian.miit.gov.cn/">{{ record }}</a>
      </p>
      <p>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=2025138906">湘ICP备 2025138906号</a>
      </p>
    </div>
  </el-row>
</template>
<script>
  export default {
    data(){
      return{
        record:''
      }
    },
    methods:{
      setRecord(){
        var curWwwPath = window.location.host;
        if(curWwwPath.indexOf('issdn')>-1){
          this.record = '湘ICP备18023659号-1'
        }else if(curWwwPath.indexOf('sxzsdn')>-1){
          this.record = '湘ICP备18023659号-2'
        }else if(curWwwPath.indexOf('sxzwan')>-1){
          this.record = '湘ICP备18023659号-3'
        }else if(curWwwPath.indexOf('xspeeder')>-1){
          this.record = '湘ICP备18023659号-4'
        }else if(curWwwPath.indexOf('dwcache')>-1){
          this.record = '湘ICP备18023659号-5'
        }else if(curWwwPath.indexOf('netsxz')>-1){
          this.record = '湘ICP备18023659号-6'
        }else if(curWwwPath.indexOf('sxzros')>-1){
          this.record = '湘ICP备18023659号-7'
        }else if(curWwwPath.indexOf('i1608')>-1){
          this.record = '湘ICP备18023659号-8'
        }else if(curWwwPath.indexOf('sxzrouter')>-1){
          this.record = '湘ICP备18023659号-9'
        }
      }
    },
    created(){
      this.setRecord();
    }
  }
</script>
<style lang="scss" scoped>
  .main-bottom {
    width: 100%;
  }
  .main-bottom .main-bottom-conts {
    width: 100%;
    background-color: #282828;
    padding: 50px 10px 30px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .main-bottom .main-bottom-conts .item-box {
    margin-bottom: 20px;
    min-height: 176px;
  }
  .main-bottom .main-bottom-conts .title {
    font-size: 16px;
    color: #fff;
    line-height: 1;
    padding-bottom: 16px;
  }
  .main-bottom .main-bottom-conts .title.zh {
    padding-bottom: 12px;
  }
  .main-bottom .main-bottom-conts .title.en {
    font-size: 10px;
  }
  .main-bottom .main-bottom-conts li {
    list-style: none;
    line-height: 1;
    padding-bottom: 12px;
    font-size: 12px;
    color: #b3b3b3;
  }
  .main-bottom .main-bottom-conts li a {
    font-size: 12px;
    color: #b3b3b3;
  }
  .main-bottom .main-bottom-conts li a:hover {
    text-decoration: underline;
    color: #fff;
  }
  .main-bottom .main-bottom-conts .item-box.code {
    text-align: center;
    img{
      width: 115px;
    }
  }
  .main-bottom .main-bottom-conts .codeimg {
    vertical-align: middle;
    width: 115px;
  }
  .main-bottom .main-bottom-conts .codetext {
    font-size: 12px;
    color: #b3b3b3;
    line-height: 30px;
  }
  .main-bottom .main-bottom-copyright {
    width: 100%;
    background-color: #1d1d1d;
    font-size: 12px;
    text-align: center;
    color: #757575;
  }
  .main-bottom .main-bottom-copyright p {
    display: inline-block;
    line-height: 40px;
    margin-right: 12px;
    &:last-child{
      margin-right: 0;
      display: block;
      text-align: center;
      line-height: 1;
      padding-bottom: 12px;
      a{
        display: inline-block;
        padding-left: 24px;
        background: url("../../assets/images/icon-police.png") no-repeat;
        background-size: 20px;
      }
    }
  }
  .main-bottom .main-bottom-copyright p a {
    line-height: 20px;
    color: #757575;
    &:hover{
      color: #ababab;
      text-decoration: underline;
    }
  }
  @media screen and (max-width: 767px) {
    .main-bottom .main-bottom-conts .item-box.code {
      text-align: left;
    }
    .main-bottom .main-bottom-copyright p {
      display: block;
      line-height: 20px;
      margin-right: 0;
    }
  }
</style>
